import { UserNotifications } from "./UserNotifications";

export default UserNotifications;
